"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingFormulaItemConditionIsInRange = exports.pricingFormulaItemConditionDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeBoolean_1 = __importDefault(require("./deserializeBoolean"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const PricingFormulaInput_1 = require("./PricingFormulaInput");
const deserializeConstraint = (value) => (0, deserializeNumber_1.deserializeNumber)(value, 0.01);
function pricingFormulaItemConditionDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        applyRangeToInputValue: (0, unwrap_1.default)(object.applyRangeToInputValue, deserializeBoolean_1.default),
        input: (0, PricingFormulaInput_1.pricingFormulaInputDeserialize)(object.input),
        minimumInclusive: (0, unwrap_1.default)(object.minimumInclusive, deserializeConstraint),
        maximumExclusive: (0, unwrap_1.default)(object.maximumExclusive, deserializeConstraint),
    };
}
exports.pricingFormulaItemConditionDeserialize = pricingFormulaItemConditionDeserialize;
function pricingFormulaItemConditionIsInRange(condition, inputValue) {
    var _a;
    if (condition.applyRangeToInputValue) {
        return inputValue >= ((_a = condition.minimumInclusive) !== null && _a !== void 0 ? _a : 0);
    }
    else {
        const passesMinimum = (0, unwrap_1.default)(condition.minimumInclusive, min => inputValue >= min, () => true);
        const passesMaximum = (0, unwrap_1.default)(condition.maximumExclusive, max => inputValue < max, () => true);
        return passesMinimum && passesMaximum;
    }
}
exports.pricingFormulaItemConditionIsInRange = pricingFormulaItemConditionIsInRange;
